<script setup lang="ts">
// The four editable date fields above the calendar (port of legacy `ControlsPanel.vue`, 67 ln).
// Copy is de-hardcoded: display values are pre-formatted by the root and placeholders are props.
import type { DateField } from './types'

withDefaults(
  defineProps<{
    compareEnabled?: boolean
    startInputLabel: string
    endInputLabel: string
    compareStartInputLabel: string
    compareEndInputLabel: string
    formattedStart?: string
    formattedEnd?: string
    formattedCompareStart?: string
    formattedCompareEnd?: string
    startPlaceholder?: string
    endPlaceholder?: string
    compareStartPlaceholder?: string
    compareEndPlaceholder?: string
    disabled?: boolean
  }>(),
  {
    compareEnabled: false,
    formattedStart: '',
    formattedEnd: '',
    formattedCompareStart: '',
    formattedCompareEnd: '',
    startPlaceholder: '',
    endPlaceholder: '',
    compareStartPlaceholder: '',
    compareEndPlaceholder: '',
    disabled: false,
  },
)

const emit = defineEmits<{ dateInput: [payload: { field: DateField; value: string }] }>()

function onChange(field: DateField, event: Event): void {
  emit('dateInput', { field, value: (event.target as HTMLInputElement).value })
}
</script>

<template>
  <div class="ui-date-picker__controls mb-md grid grid-cols-2 gap-x-sm gap-y-xs">
    <div class="ui-date-picker__field flex items-center gap-xs">
      <span
        class="ui-date-picker__swatch ui-date-picker__swatch--primary h-6 w-[0.375rem] flex-none rounded-full bg-info"
        aria-hidden="true"
      />
      <input
        type="text"
        class="ui-date-picker__input w-full rounded-md border border-border bg-surface px-xs py-2xs text-xs text-fg outline-none transition-[border-color,box-shadow] duration-150 focus:border-ring focus:shadow-[0_0_0_2px_var(--ui-color-ring)] disabled:cursor-not-allowed disabled:opacity-60"
        :value="formattedStart"
        :aria-label="startInputLabel"
        :placeholder="startPlaceholder"
        :disabled="disabled"
        @change="onChange('start', $event)"
      />
    </div>
    <div class="ui-date-picker__field flex items-center gap-xs">
      <input
        type="text"
        class="ui-date-picker__input w-full rounded-md border border-border bg-surface px-xs py-2xs text-xs text-fg outline-none transition-[border-color,box-shadow] duration-150 focus:border-ring focus:shadow-[0_0_0_2px_var(--ui-color-ring)] disabled:cursor-not-allowed disabled:opacity-60"
        :value="formattedEnd"
        :aria-label="endInputLabel"
        :placeholder="endPlaceholder"
        :disabled="disabled"
        @change="onChange('end', $event)"
      />
    </div>

    <template v-if="compareEnabled">
      <div class="ui-date-picker__field flex items-center gap-xs">
        <span
          class="ui-date-picker__swatch ui-date-picker__swatch--compare h-6 w-[0.375rem] flex-none rounded-full bg-accent"
          aria-hidden="true"
        />
        <input
          type="text"
          class="ui-date-picker__input w-full rounded-md border border-border bg-surface px-xs py-2xs text-xs text-fg outline-none transition-[border-color,box-shadow] duration-150 focus:border-ring focus:shadow-[0_0_0_2px_var(--ui-color-ring)] disabled:cursor-not-allowed disabled:opacity-60"
          :value="formattedCompareStart"
          :aria-label="compareStartInputLabel"
          :placeholder="compareStartPlaceholder"
          :disabled="disabled"
          @change="onChange('compareStart', $event)"
        />
      </div>
      <div class="ui-date-picker__field flex items-center gap-xs">
        <input
          type="text"
          class="ui-date-picker__input w-full rounded-md border border-border bg-surface px-xs py-2xs text-xs text-fg outline-none transition-[border-color,box-shadow] duration-150 focus:border-ring focus:shadow-[0_0_0_2px_var(--ui-color-ring)] disabled:cursor-not-allowed disabled:opacity-60"
          :value="formattedCompareEnd"
          :aria-label="compareEndInputLabel"
          :placeholder="compareEndPlaceholder"
          :disabled="disabled"
          @change="onChange('compareEnd', $event)"
        />
      </div>
    </template>
  </div>
</template>
